import { useState, useEffect, useCallback } from "react";
import { getUnreadCount } from "../api/unreadCount";
import { useAuth } from "../hooks/useAuth";
import { logger } from "../utils/logger";

export const useUnreadCount = () => {
  const [unreadData, setUnreadData] = useState([]); // 全タスクの未読・ユーザー情報の配列
  const [isLoading, setIsLoading] = useState(false);
  /*
  未読件数対応:
  対応日: 2026/04/12
  担当者: 越智
  修正概要: 取得条件をタスク一覧と合わせる
  */
  const { userId, identifyId, roleId } = useAuth();
  /*
  END
  未読件数対応:
  */

  /*
    故障管理一覧表: KOSHO-163
    対応日: 2026/3/27
    担当者: 越智
    修正概要: 未読件数
  */
  const fetchUnread = useCallback(
    async (userType) => {
      if (!userType) {
        logger.warn("fetchUnread was called without userType. Skipping...");
        return;
      }
      setIsLoading(true);
      try {
        // Lambdaの getUnreadCount を叩く
        /*
        未読件数対応:
        対応日: 2026/04/12
        担当者: 越智
        修正概要: 取得条件をタスク一覧と合わせる
        */
        const response = await getUnreadCount(userType, userId, identifyId, roleId);
        /*
        END
        未読件数対応:
        */

        setUnreadData([...response]);
      } catch (err) {
        logger.error("未読取得エラー:", err);
      } finally {
        setIsLoading(false);
      }
    },
    [userId]
  );
  /*
    END
    故障管理一覧表: KOSHO-163
  */

  return {
    unreadData, // [{task_id, task_title, task_unread_total, users: [...]}, ...]
    isLoading,
    fetchUnread, // 手動更新用（チャット送信後などに呼ぶ）
  };
};
